import { render, staticRenderFns } from "./TermsOfUseModal.vue?vue&type=template&id=97f3ba86&"
import script from "./TermsOfUseModal.vue?vue&type=script&lang=js&"
export * from "./TermsOfUseModal.vue?vue&type=script&lang=js&"
import style0 from "./TermsOfUseModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports